import box from '~/assets/icons/box_4.svg';
import brakeContract from '~/assets/icons/brake_contract.svg';
import clock from '~/assets/icons/clock.svg';
import delivery from '~/assets/icons/delivery.svg';
import info from '~/assets/icons/info_2.svg';
import map from '~/assets/icons/map.svg';
import tick from '~/assets/icons/tick.svg';
import { CurrencyIcon } from '~/components/collections';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Divider } from '~/components/ui/Divider';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import { TruckJobRarity } from '../AppTruckJob/AppTruckJob.model';
import {
	StyledBottomContainer,
	StyledContainer,
	StyledHeader,
	StyledInfoContainer,
	StyledInfoHeadContainer,
	StyledInfoItemContainer,
	StyledInfoPriceContainer,
	StyledInfoTimeContainer,
	StyledMapCaption,
	StyledMapContainer,
	StyledOrderProgressBar,
	StyledOrderProgressBarWrapper,
	StyledOrderProgressContainer,
	StyledOrderProgressStep,
	StyledOrderProgressStepsContainer,
	StyledOrderTag,
	StyledTagsContainer,
	StyledTimeTag,
	StyledTopContainer,
} from './AppTruckJobActiveOrder.styled';

const AppTruckJobActiveOrder = () => {
	const rubleIcon = useWalletIcon(Currency.Ruble, true);
	const active = false;

	return (
		<StyledContainer>
			<StyledTopContainer>
				<Text
					style={{
						fontSize: 12,
						fontWeight: 400,
						color: '#ffffff',
						opacity: 0.25,
					}}
				>
					Заказ №2344
				</Text>
				<StyledHeader>
					<Text style={{ fontSize: 18, fontWeight: 500, color: '#ffffff' }}>
						Древесина
					</Text>
					<StyledTagsContainer>
						<StyledOrderTag className={TruckJobRarity.EPIC}>
							<Text>Эпический</Text>
						</StyledOrderTag>
						<StyledTimeTag>
							<ImgIcon icon={clock} width={10} height={10} color="#000000" />
							<Text>10:00</Text>
						</StyledTimeTag>
					</StyledTagsContainer>
				</StyledHeader>
			</StyledTopContainer>
			<StyledMapContainer>
				<ImgIcon
					icon={map}
					width={20}
					height={20}
					color="#ffffff"
					style={{ position: 'absolute', top: 60, left: 120 }}
				/>
				<StyledMapCaption>
					<ImgIcon icon={map} width={14} height={14} color="#ffffff" />
					<Text>Склад 2</Text>
					<Text style={{ opacity: 0.5 }}>—</Text>
					<Text>Сэнди-Шорс</Text>
				</StyledMapCaption>
			</StyledMapContainer>
			<StyledInfoContainer>
				<StyledInfoHeadContainer>
					<ImgIcon
						icon={info}
						width={20}
						height={20}
						color="#ffffff"
						style={{ opacity: 0.75 }}
					/>
					<Text>О заказе</Text>
				</StyledInfoHeadContainer>
				<StyledInfoItemContainer>
					<Text>Срок доставки</Text>
					<StyledInfoTimeContainer>
						<Text>10:00</Text>
						<ImgIcon icon={clock} width={14} height={14} color="#FFBB00" />
					</StyledInfoTimeContainer>
				</StyledInfoItemContainer>
				<StyledInfoItemContainer>
					<Text>Дальность поездки</Text>
					<Text style={{ fontSize: 14, fontWeight: 500, color: '#ffffff' }}>
						5.5 <span style={{ fontWeight: 400, opacity: 0.5 }}>км.</span>
					</Text>
				</StyledInfoItemContainer>
				<StyledInfoItemContainer>
					<Text>Получаемый опыт</Text>
					<Text style={{ fontSize: 14, fontWeight: 500, color: '#ffffff' }}>
						15 EXP
					</Text>
				</StyledInfoItemContainer>
				<StyledInfoItemContainer>
					<Text>Оплата за заказ</Text>
					<StyledInfoPriceContainer>
						<Text>10 000</Text>
						<CurrencyIcon icon={rubleIcon} size="sm" style={{ opacity: 0.5 }} />
					</StyledInfoPriceContainer>
				</StyledInfoItemContainer>
			</StyledInfoContainer>
			<Divider $direction="H" $color="#ffffff" style={{ opacity: 0.1 }} />
			{active && (
				<StyledBottomContainer>
					<StyledOrderProgressContainer>
						<Text style={{ fontSize: 14, fontWeight: 500, color: '#FFBB00' }}>
							Заберите заказ
						</Text>
						<StyledOrderProgressStepsContainer>
							<StyledOrderProgressStep $completed>
								<ImgIcon icon={delivery} width={10} height={10} />
							</StyledOrderProgressStep>
							<StyledOrderProgressBarWrapper>
								<StyledOrderProgressBar style={{ width: '50%' }} />
							</StyledOrderProgressBarWrapper>
							<StyledOrderProgressStep>
								<ImgIcon icon={box} width={10} height={10} />
							</StyledOrderProgressStep>
							<StyledOrderProgressBarWrapper>
								<StyledOrderProgressBar style={{ width: '0' }} />
							</StyledOrderProgressBarWrapper>
							<StyledOrderProgressStep>
								<ImgIcon icon={tick} width={10} height={10} />
							</StyledOrderProgressStep>
						</StyledOrderProgressStepsContainer>
					</StyledOrderProgressContainer>
					<Button
						color={ButtonColors.Cancel}
						height={ButtonHeight.Height50}
						square
					>
						<img src={brakeContract} width={20} height={20} />
					</Button>
				</StyledBottomContainer>
			)}
			{!active && (
				<Button
					color={ButtonColors.LightGreen}
					height={ButtonHeight.Height50}
					style={{ fontSize: 16, fontWeight: 500, marginTop: 10 }}
				>
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						<img src={delivery} width={20} height={20} />
						<Text>Взять заказ</Text>
					</div>
				</Button>
			)}
		</StyledContainer>
	);
};

export { AppTruckJobActiveOrder };
